<template>
  <div>
    <ul class="nav nav-tabs product-nav-tabs" id="product-tabs">
      <template v-for="item in navTabs">
        <li :id="item.id" :class="activeTab(item.id)" :key="item.id" @click="changeTab(item.id)">
          <a>{{ item.name }}</a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import tabs from '@/common/products-tabs'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      navTabs: tabs
    }
  },
  props: {
    tab: {
      type: String,
      default: 'list'
    }
  },
  methods: {
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    },
    changeTab (tabName) {
      let availableTabs = ['list', 'add-by-amazon', 'reports']
      if (availableTabs.includes(tabName)) {
        let logParamsName = eventCode.manage_products.list_tab.show
        if (tabName === 'add-by-amazon') {
          logParamsName = eventCode.manage_products.add_by_amazon_tab.show
        } else if (tabName === 'reports') {
          logParamsName = eventCode.manage_products.report_tab.show
        }
        // Remove lock from all tabs before locking the new one — rapid clicks leave multiple tabs permanently unclickable otherwise.
        clearTimeout(this._disableTabTimer)
        $('.disabled-tab').removeClass('disabled-tab')
        this._disableTabTimer = setTimeout(() => {
          $(`#${tabName}`).addClass('disabled-tab')
        }, 100)

        let logParams = {
          name: logParamsName,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }
      this.$router.push(`/products-new/${tabName}`)
    }
  }
}
</script>

<style scoped>
.product-nav-tabs {
  border-bottom: 1px solid #ddd;
}
.product-nav-tabs li {
  margin: 0 5px 0 0;
  font-weight: bold;
}
.product-nav-tabs li a {
  color: #000;
  background-color: #eaeaea;
  width: 180px;
  text-align: center;
  padding: 5px 10px;
  border: 1px solid #a3a3a3;
}
.product-nav-tabs li.active a {
  color: #fff;
  background-color: #005899;
  border: 1px solid #005899;
}
.product-nav-tabs li a:hover {
  cursor: pointer;
  opacity: 0.8;
}
@media (max-width: 576px) {
  .product-nav-tabs li {
    margin: 0;
  }
  .product-nav-tabs li a {
    width: 120px;
    padding: 4px 0;
  }
}
@media (max-width: 320px) {
  .product-nav-tabs li {
    margin: 0;
  }
  .product-nav-tabs li a {
    width: 104px;
    padding: 4px 0;
    font-size: 11px;
  }
}
.disabled-tab {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/NavTabs.vue